export const PROFILE_GAPS = [
  "unverified",
  "not_onboarded",
  "no_photo",
  "few_interests",
  "no_academics",
] as const;

export type ProfileGap = (typeof PROFILE_GAPS)[number];

export const PROFILE_GAP_LABELS: Record<ProfileGap, { label: string; description: string }> = {
  unverified: { label: "Email not verified", description: "Never entered the signup code" },
  not_onboarded: { label: "Onboarding not finished", description: "Stopped partway through signup" },
  no_photo: { label: "No photo", description: "No profile picture" },
  few_interests: { label: "Fewer than 3 interests", description: "Onboarding asks for 3 or more" },
  no_academics: { label: "No area of study", description: "Missing area of study or graduation year" },
};

export interface IncompleteProfile {
  _id: string;
  first_name: string;
  last_name: string;
  email: string;
  avatar_url: string | null;
  school_name: string | null;
  campus_name: string | null;
  interest_count: number;
  created_at: string;
  last_active_at: string | null;
  missing: ProfileGap[];
}

export interface IncompleteProfilesResponse {
  users: IncompleteProfile[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
  summary: Record<ProfileGap, number>;
}
